<template>
<v-responsive :aspect-ratio="16/9" @click="onClick" class="grey darken-4" :style="clickStyle">
  <div :style="thumbStyle"></div>
  <faces-detection :faces="faces"></faces-detection>
  <img :src="imageUrlPreload" @load="onLoaded" @error="onError" style="display:none"></img>
</v-responsive>
</template>

<script>
import FacesDetection from './FacesDetection'

export default {
  name: 'CameraThumb',
  props: {
    src: {
      type: String
    },
    faces: {
      type: Array
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'faces-detection': FacesDetection
  },
  data() {
    return {
      loading: true,
      triedCount: 0,
      imageUrl: null,
      imageUrlPreload: null
    }
  },
  computed: {
    thumbStyle() {
      return {
        'background-image': `url("${this.imageUrl}")`,
        'background-size': `100% 100%`,
        'height': '100%',
        'width': 'auto'
      }
    },
    clickStyle() {
      if (this.clickable && !this.loading) return {
        cursor: 'pointer'
      };
    }
  },
  methods: {
    onLoaded() {
      this.loading = false;
      this.imageUrl = this.imageUrlPreload;
    },
    onClick() {
      if (this.clickable && this.imageUrl) {
        this.$emit('click', this.src);
      }
    },
    onError(e) {
      this.triedCount++;
      let url = `${this.src}&${new Date().getTime()}`;
      if (this.triedCount < 3) setTimeout(() => {
        this.imageUrlPreload = url;
      }, 1000);
    }
  },
  watch: {
    src(val) {
      this.loading = true;
      this.triedCount = 0;
      this.imageUrl = null;
      this.imageUrlPreload = this.src;
    }
  },
  mounted() {
    this.loading = true;
    this.imageUrl = null;
    this.imageUrlPreload = this.src;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/CameraThumb.vue